module.exports = __webpack_public_path__ + "img/logo_11.179a41e7.png";